<template>
  <div class='navContainer'>
    <b-nav vertical class="adminNav">
      <b-nav-item  v-for="(component, index) in components" :key="`component-${index}`" :to="component.path" :class="isActive(component.name)" @click="makeActive(component.name)">
        <span class='menu-left'><fa :icon="component.icon" />  {{component.name}}</span>
      </b-nav-item>
      <b-nav-item class="back" @click="$router.go(-1)">Back
      </b-nav-item>
    </b-nav>
    <b-nav vertical class="mailboxNav">
    </b-nav>
  </div>
</template>
<script>
export default {
  name: 'NavAdmin',
  data () {
    return {
      active: '',
      components: [
        {name: 'Mailboxes', icon: 'envelope', path: '/admin/mailboxes'},
        {name: 'Teams', icon: 'users', path: '/admin/teams'},
        {name: 'Jotforms', icon: 'address-card', path: '/admin/jotforms'},
        {name: 'Templates', icon: 'puzzle-piece', path: '/admin/task_templates_collections'},
        {name: 'Users', icon: 'user', path: '/admin/users'},
        {name: 'Clients', icon: 'id-badge', path: '/admin/clients'},
        {name: 'Tags', icon: 'tags', path: '/admin/tags'},
        {name: 'Saved Replies', icon: 'tags', path: '/admin/saved_replies'},
        {name: 'Reports', icon: 'address-card', path: '/admin/reports'},
        {name: 'Fields', icon: 'address-card', path: '/admin/fields'}
      ]
    }
  },
  methods: {
    isActive (name) {
      return this.active === name ? 'active' : 'inactive'
    },
    makeActive (name) {
      this.active = name
    }
  },

  beforeDestroy () {
    this.active = ''
  }
}
</script>
<style scoped>
  .inactive a {
    color: #e0e0e0;
  }
  .active a {
    color: #fff5f5;
  }
  .menu-left {
    padding: 5px;
    display: block;
    float: left;
  }
  .menu-right {
    padding: 5px;
    display: block;
    float: right;
  }
  .navContainer {
    margin: 7px;
  }
  .back:hover {
    background: #3D829A;
  }
  .back a {
    color: #e0e0e0;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavAdmin.vue